import React, { Component } from "react";
import { Link, Switch, Route } from "react-router-dom";

import { put } from "../../api";
import { emit } from "../../events";
import capitalize from "../../capitalize";

import EditLBUTypes from "./EditLBUTypes";
import EditCategories from "./EditCategories";
import EditBlockWords from "./EditBlockWords";
import EditBrandNames from "./EditBrandNames";
import EditProductNames from "./EditProductNames";

import { PenIcon } from "../SVGIcons";

import "./StructuredDetails.css";

class StructuredDetails extends Component {
  closeModal = () => {
    this.props.history.goBack();
  };

  updateLBU = async data => {
    try {
      const lbu = await put("/lbus/" + this.props.lbu.id, data);
      emit("lbu_updated", lbu);
      this.closeModal();
    } catch (err) {
      alert(err.message);
    }
  };

  render() {
    const {
      id,
      lbuTypes = [],
      categories = [],
      blockWords = [],
      brandNames = [],
      productNames = []
    } = this.props.lbu;

    return (
      <div className="StructuredDetails">
        <h2>
          LBU types
          <Link to={`/lbus/${id}/structured/edit_lbu_types`}>
            <PenIcon />
          </Link>
        </h2>
        <div>{lbuTypes.map(type => capitalize(type)).join(" · ")}</div>

        <h2>
          Categories
          <Link to={`/lbus/${id}/structured/edit_categories`}>
            <PenIcon />
          </Link>
        </h2>
        <ul className="categoryList">
          {categories.map(category => {
            const searchWords = category.searchWords || [];
            return (
              <li key={category.id}>
                <Link to={`/categories/${category.id}`}>
                  {capitalize(category.name)} ({searchWords.length})
                </Link>
                <div>
                  {searchWords.slice(0, 10).join(" · ")}
                  <span> · </span>
                  <Link
                    style={{ textDecoration: "underline" }}
                    to={`/categories/${category.id}`}
                  >
                    more
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>

        <h2>
          Block words
          <Link to={`/lbus/${id}/structured/edit_block_words`}>
            <PenIcon />
          </Link>
        </h2>
        <div>{blockWords.join(" · ")}</div>

        <h2>
          Brand names
          <Link to={`/lbus/${id}/structured/edit_brand_names`}>
            <PenIcon />
          </Link>
        </h2>
        <div>{brandNames.join(" · ")}</div>

        <h2>
          Product names
          <Link to={`/lbus/${id}/structured/edit_product_names`}>
            <PenIcon />
          </Link>
        </h2>
        <div>{productNames.join(" · ")}</div>

        <Switch>
          <Route
            path="/lbus/:id/structured/edit_lbu_types"
            render={() => (
              <EditLBUTypes
                lbuTypes={lbuTypes}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/structured/edit_categories"
            render={() => (
              <EditCategories
                categories={categories}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/structured/edit_block_words"
            render={() => (
              <EditBlockWords
                blockWords={blockWords}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/structured/edit_brand_names"
            render={() => (
              <EditBrandNames
                brandNames={brandNames}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
          <Route
            path="/lbus/:id/structured/edit_product_names"
            render={() => (
              <EditProductNames
                productNames={productNames}
                onClose={this.closeModal}
                onSave={this.updateLBU}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default StructuredDetails;



// WEBPACK FOOTER //
// ./src/components/LBUs/StructuredDetails.js